import * as angular from 'angular';

export default function ($window) {
  var win = angular.element($window);

  // We only want a single window resize watcher, no matter how many elements need to react
  // This lets other elements bind hooks that will fire when the width changes, the height changes, or either changes

  var width = win.width();
  var height = win.height();
  var anyResizeHooks = []; // hooks that will fire on any resize
  var heightHooks = []; // hooks that will fire only when height changes
  var widthHooks = []; // hooks that will fire only when width changes

  win.bind('resize', function () {
    var newWidth = win.width();
    var newHeight = win.height();

    // TODO: add throttling? 20-30ms?

    if (width !== newWidth || height !== newHeight) {
      angular.forEach(anyResizeHooks, function (hook) {
        hook();
      });
    }

    if (height !== newHeight) {
      angular.forEach(heightHooks, function (hook) {
        hook();
      });

      height = newHeight;
    }

    if (width !== newWidth) {
      angular.forEach(widthHooks, function (hook) {
        hook();
      });

      width = newWidth;
    }
  });

  return {
    onResize: function (hook) {
      anyResizeHooks.push(hook);
    },

    onHeightResize: function (hook) {
      heightHooks.push(hook);
    },

    onWidthResize: function (hook) {
      widthHooks.push(hook);
    }
  };
}
